var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "title-container" }, [_vm._v("Centro de ayuda")]),
    _c(
      "ul",
      { staticClass: "help-widgets-container" },
      _vm._l(_setup.helpWidgets, function (widget, index) {
        return _c("li", { key: index, staticClass: "help-widget" }, [
          _c(
            "a",
            {
              staticClass: "help-widget-link",
              attrs: { href: widget.url, target: "_blank" },
            },
            [_vm._v(" " + _vm._s(widget.text) + " ")]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }